export const APPLICATION_AUTH = "application_auth"
export const telegramBotUsername = "pikatweetbot"
export const defaultThemeColor = "#D4FB5F"
export const defaultThemeColorSec = "#92b820"

export const DEFAULT_APPROVE_VALUE = "115792089237316195423570985008687907853269984665640564039457584007913129639935"
export const bscTestNetPaymentContractAddress = '0xA35C19F3E1868A2c04f69474A3E9F3d6734b7aaf'
export const paymentTokenAddress = '0xd0387ec92bf4bd532f3c10b49130b9af1CF2c52E'